import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { ItemProdutoInserirComponent } from "./item-produto-inserir.component";
import { ItemProdutoInserirRoutingModule } from "./item-produto-inserir-routing.module";

import { ButtonModule } from "primeng/button";;
import { InputTextModule } from "primeng/inputtext";
import { TableModule } from 'primeng/table';
import { HttpClientModule } from "@angular/common/http";
import { DividerModule } from "primeng/divider";
import { ConfirmationService } from "primeng/api";
import { FormsModule } from "@angular/forms";
import { MessagesModule } from "primeng/messages";
import { MessageModule } from 'primeng/message';
import { DropdownModule } from "primeng/dropdown";
import { InputSwitchModule } from "primeng/inputswitch";
import { InputNumberModule } from "primeng/inputnumber";
import { InputMaskModule } from "primeng/inputmask";
import { DialogModule } from "primeng/dialog";
import { ProgressSpinnerModule } from "primeng/progressspinner";


@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ItemProdutoInserirRoutingModule,
        ButtonModule,
        InputTextModule,
        TableModule,
        HttpClientModule,   
        DividerModule,
        MessagesModule,
        MessageModule,
        DropdownModule,
        InputSwitchModule,
        InputNumberModule,
        InputMaskModule,
        DialogModule,
        ProgressSpinnerModule
        
    ],
    providers: [ConfirmationService],
    declarations: [ItemProdutoInserirComponent]
})
export class ItemProdutoInserirModule { }
